
import { useState } from "react";
import { updateRolesForm } from "../../lib/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThreeDot } from "react-loading-indicators";

export default function EditRolesUi({ data }) {

    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const result = await updateRolesForm(data.id, new FormData(e.target), navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    if (Object.keys(data)?.length < 1 ){
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 w-full gap-4">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "name of role" : "الاسم الدور "} </label>
                    <input
                        type="text"
                        name="name"
                        defaultValue={data.name}
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name of role " : "أدخل اسم الدور"}
                    />
                </div>
                <div className="mb-4">
                        <label className="block text-white mb-2"> {currentLang === "en" ? "navigate (must start with /)" : " يجب البدء ب / المسار"} </label>
                        <input
                            type="text"
                            name="navigate"
                            defaultValue={data?.navigate}
                            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                            required
                            placeholder={currentLang === "en" ? "enter the route to navigate when login of role " : "أدخل المسار الذي تريد التنقل إليه عند تسجيل الدخول إلى الدور"}

                        />
                </div>
            </div>

            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};